module.exports = __webpack_public_path__ + "assets/error.700bd717.svg";